import swal from 'sweetalert';

(() => {
  angular.module('app').component('memberCardComponent', {
    templateUrl: require('./memberCard.component.html'),
    controller: MemberCardController,
    controllerAs: 'vm',
    bindings: {      
      employee: '<',
      permissions: '<',
      enums: '<',
      settings: '<',
      canApplyPostHospitalizationGl: '<'
    }
  });

  MemberCardController.$inject = [
    '$state',
    '$uibModal',
    'abp.services.app.hostEmployee',
    'appConstants',];

  function MemberCardController(
    $state,
    $uibModal,
    hostEmployeeSvc,
    appConstants,
  ) {
    const vm = this;

    vm.getUserBgColor = getUserBgColor;
    vm.getUserInitial = getUserInitial;
    vm.toggleFlagged = toggleFlagged;

    vm.checkAccess = checkAccess;
    vm.viewClaimPolicy = viewClaimPolicy;
    vm.getUncoveredTreatments = getUncoveredTreatments;
    vm.getGLHistory = getGLHistory;
    vm.createManualTransactionRequest = createManualTransactionRequest;

    vm.createGuaranteeLetter = createGuaranteeLetter;
    vm.createPostHospitalizationGuaranteeLetter = createPostHospitalizationGuaranteeLetter;

    vm.openInsuranceEndorsementModal = openInsuranceEndorsementModal;
    vm.unflagInsuranceEndorsementFlaggedMember = unflagInsuranceEndorsementFlaggedMember;
    vm.viewExclusionList = viewExclusionList;
    vm.viewScheduleOfBenefits = viewScheduleOfBenefits;
    vm.getInpatientGlHistory = getInpatientGlHistory;
    vm.getEmployeeSpecialNotes = getEmployeeSpecialNotes;

    vm.createInpatientNprClaim = createInpatientNprClaim;
    vm.getAdmissionRecords = getAdmissionRecords;

    vm.getVisibleActivitiesForEmployee = getVisibleActivitiesForEmployee;
    vm.toggleEmployeeActivityView = toggleEmployeeActivityView;
    vm.getActivityLabel = getActivityLabel;
    vm.getClinicTypeLabel = getClinicTypeLabel;
    vm.getGlStatusLabel = getGlStatusLabel;

    function getUserBgColor(id) {
      return `user_bgcolor_${((id || 0) % 8) + 1}`;
    }

    function getUserInitial(user) {
      const fullName = (user.name || ' ').split(' ');
      let initial = '';
      for (let i = 0; i < fullName.length; i += 1) {
        if (fullName[i].length) {
          initial += fullName[i][0];
        }
      }
      if (initial && initial.length > 3) initial = `${initial[0]}`;
      return initial;
    }
    
    function toggleFlagged(employee) {
      if (vm.loading) return;
      const attemptFlag = !employee.isFlagged;

      vm.loading += 1;
      hostEmployeeSvc
        .flagEmployee({
          employeeId: employee.id,
          isFlagged: attemptFlag,
        })
        .success(() => {
          employee.isFlagged = attemptFlag;
          abp.notify.info(
            App.localize(
              employee.isFlagged ? 'PatientXFlagged' : 'PatientXUnflagged',
              employee.name
            )
          );
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function checkAccess(employeeId) {
      $uibModal.open({
        templateUrl: require('../checkAccess/checkAccessModal.html'),
        controller: 'host.views.employees.checkAccessModal as vm',
        backdrop: 'static',
        resolve: {
          employeeId() {
            return employeeId;
          },
        },
      });
    }

    function viewClaimPolicy(employee) {
      $uibModal.open({
        templateUrl: require('../claimPolicy/claimPolicy.modal.html'),
        controller: 'host.views.employees.claimPolicyModal as vm',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          memberId() {
            return employee.id;
          },
        },
      });
    }

    function getUncoveredTreatments(employeeId, serviceType, serviceTypeName) {
      $uibModal.open({
        templateUrl: require('../uncoveredTreatmentTree/uncoveredTreatmentTreeModal.html'),
        controller: 'host.views.employees.uncoveredTreatmentTreeModal as vm',
        backdrop: 'static',
        resolve: {
          employeeId() {
            return employeeId;
          },
          serviceType() {
            return serviceType;
          },
          serviceTypeName() {
            return serviceTypeName;
          },
        },
      });
    }

    function getGLHistory(employeeId) {
      $uibModal.open({
        templateUrl: require('../getGLHistory/getGLHistoryModal.html'),
        controller: 'host.views.employees.getGLHistoryModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          employeeId() {
            return employeeId;
          },
        },
      });
    }

    function createManualTransactionRequest(employee) {
      if (employee.hasViewMemberPermission) {
        redirect(employee.corporateCode, employee.nationalId);
      } else {
        hostEmployeeSvc
          .getEmployeeNationalId({
            employeeId: employee.id,
          })
          .success((data) => {
            redirect(employee.corporateCode, data);
          });
      }

      function redirect(corporateCode, nationalId) {
        $state.go('finance.createEditManualTransactionRequest', {
          isCreate: true,
          tenancyName: corporateCode,
          transactionTenantType: vm.enums.transactionTenantType.Member.id,
          nationalId,
        });
      }
    }

    function createGuaranteeLetter(employee) {
      $uibModal.open({
        templateUrl: require('../../../../common/views/guaranteeLetters/createModal.html'),
        controller: 'common.views.guaranteeLetters.createModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          employee() {
            return employee;
          },
        },
      });
    }

    function createPostHospitalizationGuaranteeLetter(employee) {
      if (!employee.hasPostHospitalization) {
        swal({
          title: App.localize('CorporateNoPostHospitalizationTitle'),
          text: App.localize('CorporateNoPostHospitalizationMessage'),
          type: 'error',
        });

        return;
      }

      $uibModal.open({
        templateUrl: require('../../../../common/views/postHospitalization/guaranteeLetters/createModal.html'),
        controller: 'common.views.postHospitalization.guaranteeLetters.createModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          employee() {
            return employee;
          },
        },
      });
    }

    function openInsuranceEndorsementModal(employee) {
      $uibModal.open({
        templateUrl: require('../../../../common/views/modals/memberInsuranceEndorsement/memberInsuranceEndorsement.modal.html'),
        controller: 'common.views.member.insuranceEndorsementModal as vm',
        backdrop: 'static',
        resolve: {
          employeeId: employee.id,
          relationship: () => employee.relationship,
        },
      });
    }

    function unflagInsuranceEndorsementFlaggedMember(employee) {
      if (!vm.permissions.canManageInsuranceEnrolmentFlag) return;

      vm.loading += 1;
      const updatedFlag = !employee.isInsuranceEnrolmentFlagged;

      hostEmployeeSvc
        .unflagMemberInsuranceEndorsementFlag({
          employeeId: employee.id,
          isFlagged: updatedFlag,
        })
        .success(() => {
          employee.isInsuranceEnrolmentFlagged = updatedFlag;
          abp.notify.info(App.localize('MemberInsuranceEnrolmentXUnflagged', employee.name));
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function viewExclusionList(inpatientSettings) {
      $uibModal.open({
        templateUrl: require('../exclusionList/exclusionList.modal.html'),
        controller: 'host.views.employees.exclusionListModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          inpatientSettings,
        },
      });
    }

    function viewScheduleOfBenefits(serviceType, settings, employeeType, employeeUtilization) {
      $uibModal.open({
        templateUrl: require('../scheduleOfBenefits/scheduleOfBenefits.modal.html'),
        controller: 'host.views.employees.scheduleOfBenefitsModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          serviceType,
          hospitalizationSetting: settings,
          maternitySetting: settings,
          employeeType,
          countryInfo: {
            countryCode: null,
            currencyCode: null,
          },
          employeeUtilization,
        },
      });
    }

    function getInpatientGlHistory(employeeId, serviceType) {
      $uibModal.open({
        templateUrl: require('../inpatientGlHistory/inpatientGlHistory.modal.html'),
        controller: 'host.views.employees.inpatientGlHistory.inpatientGlHistoryModal as vm',
        backdrop: 'static',
        size: 'xl',
        resolve: {
          employeeId() {
            return employeeId;
          },
          serviceType() {
            return serviceType;
          },
        },
      });
    }

    function getEmployeeSpecialNotes(employeeId, specialNotes) {
      $uibModal
        .open({
          templateUrl: require('../../../../common/views/modals/remarks/remarks.modal.html'),
          controller: 'common.views.modals.remarksModal as vm',
          backdrop: 'static',
          resolve: {
            title() {
              return App.localize('SpecialNotes');
            },
            existingRemarks() {
              return specialNotes;
            },
            remarksMaxLength() {
              return appConstants.serviceRequestMaxLength;
            },
          },
        })
        .result.then((data) => {
          hostEmployeeSvc
            .setEmployeeSpecialNotes({
              id: employeeId,
              specialNotes: data,
            })
            .success(() => {
              vm.getEmployees();
            });
        });
    }

    function createInpatientNprClaim(claimType, employeeId) {
      $state.go('host.createInpatientNprClaim', {
        claimType,
        employeeId,
      });
    }

    function getAdmissionRecords(claimType, employeeId) {
      $uibModal.open({
        templateUrl: require('../getAdmissionRecords/getAdmissionRecordsModal.html'),
        controller: 'host.views.employees.getAdmissionRecordsModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          claimType() {
            return claimType;
          },
          employeeId() {
            return employeeId;
          },
        },
      });
    }

    function toggleEmployeeActivityView(employee) {
      employee.showAllActivities = !employee.showAllActivities;
    };

    function getVisibleActivitiesForEmployee(employee) {
      return employee.showAllActivities
        ? (employee.recentActivities || [])
        : (employee.recentActivities || []).slice(0, 3);
    }

    function getActivityLabel(activity = {}) {
      const { status, requestType, requestStatus, glStatus } = activity;
      const { enums } = vm;
    
      const sessionLabels = {
        [enums.patientSessionStatus.Active.id]: App.localize('ActiveCheckin'),
        [enums.patientSessionStatus.Completed.id]: App.localize('TicketSubmitted'),
        [enums.patientSessionStatus.Voided.id]: App.localize('CheckedOut'),
        [enums.patientSessionStatus.Expired.id]: App.localize('ExpiredSession'),
        [enums.patientSessionStatus.ClaimProcessing.id]: App.localize('ClaimSubmitted'),
        [enums.patientSessionStatus.PendingResubmission.id]: App.localize('PendingResubmission')
      };
    
      const requestLabelKeys = {
        [enums.requestType.Adjustment.id]: 'TopUpAddOnRequestSubmitted',
        [enums.requestType.AddOn.id]: 'TopUpAddOnRequestSubmitted',
        [enums.requestType.Initial.id]: 'IglRequestSubmitted',
        [enums.requestType.Final.id]: 'FglRequestClaimSubmitted',
        [enums.requestType.LateSubmission.id]: 'LateClaimSubmitted'
      };
    
      if (glStatus === enums.glStatus.Expired.id) {
        return App.localize('ExpiredSession');
      }
    
      if (status === enums.patientSessionStatus.Voided.id) {
        return sessionLabels[status];
      }
    
      if (
        requestType === enums.requestType.CheckIn.id &&
        requestStatus === enums.requestStatus.Approved.id
      ) {
        return sessionLabels[enums.patientSessionStatus.Active.id];
      }
    
      const labelKey = requestLabelKeys[requestType];
      if (labelKey) {
        return App.localize(labelKey);
      }
    
      return sessionLabels[status] || null;
    }
    
    function getClinicTypeLabel(panelType, serviceType) {
      const { serviceType: serviceTypeEnum, tenantClinicType: clinicTypeEnum } = vm.enums;
    
      const labelMap = {
        // ServiceType mappings.
        [serviceTypeEnum.GP.id]: {
          icon: '<i class="activities-gp fas fa-stethoscope"></i>',
          labelKey: 'GP'
        },
        [serviceTypeEnum.Dental.id]: {
          icon: '<i class="activities-dental mdi mdi-tooth"></i>',
          labelKey: 'Dental'
        },
        [serviceTypeEnum.Optical.id]: {
          icon: '<i class="activities-optical mdi mdi-sunglasses"></i>',
          labelKey: 'Optical'
        },
        [serviceTypeEnum.PreEmployment.id]: {
          icon: '<i class="activities-preemployment far fa-file-chart-pie"></i>',
          labelKey: 'PreEmployment'
        },
        [serviceTypeEnum.Specialist.id]: {
          icon: '<i class="activities-specialist fas fa-user-md"></i>',
          labelKey: 'Outpatient specialist'
        },
        [serviceTypeEnum.Pharmacy.id]: {
          icon: '<i class="activities-pharmacy far fa-capsules"></i>',
          labelKey: 'Pharmacy'
        },
        [serviceTypeEnum.Hospitalization.id]: {
          icon: '<i class="activities-inpatient fas fa-bed"></i>',
          labelKey: 'Inpatient'
        },
        [serviceTypeEnum.Maternity.id]: {
          icon: '<i class="activities-maternity fas fa-female"></i>',
          labelKey: 'Maternity'
        },
        [serviceTypeEnum.HealthScreening.id]: {
          icon: '<i class="activities-healthscreening fas fa-user-md"></i>',
          labelKey: 'HealthScreening'
        },
        [serviceTypeEnum.PostHospitalization.id]: {
          icon: '<i class="activities-inpatient fas fa-bed"></i>',
          labelKey: 'PostHospitalization'
        },
    
        // PanelType mappings.
        [clinicTypeEnum.GP.id]: {
          icon: '<i class="activities-gp fas fa-stethoscope"></i>',
          labelKey: 'GP'
        },
        [clinicTypeEnum.Dental.id]: {
          icon: '<i class="activities-dental mdi mdi-tooth"></i>',
          labelKey: 'Dental'
        },
        [clinicTypeEnum.Optical.id]: {
          icon: '<i class="activities-optical mdi mdi-sunglasses"></i>',
          labelKey: 'Optical'
        },
        [clinicTypeEnum.Specialist.id]: {
          icon: '<i class="activities-specialist fas fa-user-md"></i>',
          labelKey: 'Outpatient specialist'
        },
        [clinicTypeEnum.Pharmacy.id]: {
          icon: '<i class="activities-pharmacy far fa-capsules"></i>',
          labelKey: 'Pharmacy'
        },
        [clinicTypeEnum.Hospital.id]: {
          icon: '<i class="activities-inpatient fas fa-bed"></i>',
          labelKey: 'Inpatient'
        },
        [clinicTypeEnum.PreEmployment.id]: {
          icon: '<i class="activities-preemployment far fa-file-chart-pie"></i>',
          labelKey: 'PreEmployment'
        },
        [clinicTypeEnum.IhmAso.id]: {
          icon: '<i class="activities-ihmaso fas fa-bed"></i>',
          labelKey: 'IhmAso'
        }
      };
    
      const entry = labelMap[serviceType] || labelMap[panelType];
    
      return entry ? `${entry.icon} ${App.localize(entry.labelKey)}` : App.localize('Unspecified');
    }
    
    function getGlStatusLabel(activity) {
      const { requestType, requestStatus } = activity;
    
      const labelMap = {
        [`${vm.enums.requestType.Initial.id}_${vm.enums.requestStatus.PendingApproval.id}`]: App.localize('InitialPendingApproval'),
        [`${vm.enums.requestType.Adjustment.id}_${vm.enums.requestStatus.PendingApproval.id}`]: App.localize('TopupAddonPendingApproval'),
        [`${vm.enums.requestType.AddOn.id}_${vm.enums.requestStatus.PendingApproval.id}`]: App.localize('TopupAddonPendingApproval'),
        [`${vm.enums.requestType.Final.id}_${vm.enums.requestStatus.PendingApproval.id}`]: App.localize('FinalPendingApproval')
      };
    
      const key = `${requestType}_${requestStatus}`;
      return labelMap[key] || null;
    }
  }
})();
